export const LAUNCH_DARKLY_ERRORS = {
  initialisation: 'LaunchDarklyInitialisationError',
  provider: 'LaunchDarklyProviderError',
  userIdentification: 'LaunchDarklyUserIdentificationError',
} as const;
